export enum Routes {
  MarketplaceRouter = "*",
  MarketplaceSearchPageRouter = "/marketplace/search",
  MarketplaceDetailPageRouter = "/marketplace/:id/detail",
}
